<div class="delete-data-container">
  @if (deletionSuccessful) {
    <div class="message">
      <div style="text-align: left;">
        <h1>Your TYT account has been deleted</h1>
        @if (originalUser) {
          <p>Your TYT account with email address <strong>{{originalUser.email}}</strong>
        is now deleted.</p>
      }
      @if (!originalUser) {
        <p>Your TYT account has been deleted.</p>
      }
      <p>All personal data related to you and your account has been deleted. This includes, but is not
      limited to:</p>
      <ul>
        <li>Your name, avatar, profile information, and any other personally identifiable data</li>
        <li>Your email address and records of all previous email addresses which were associated
          with the account along with any information we maintain about you for email
        marketing purposes</li>
        <li>Watch history on TYT.com and our mobile apps</li>
        <li>Stored credit card information (if any)</li>
        <li>Your content customization settings (which shows/hosts you followed, etc)</li>
        <li>The comments you posted on TYT.com</li>
        <li>Messages included with membership gifts you've purchased</li>
        <li>Feedback you've given us about your membership experience</li>
      </ul>
      <p>You have been signed out of all devices and will be unable to sign back in to your account.
      Click below to return to TYT.com.</p>
      <a href="https://tyt.com/">Return to TYT.com</a>
    </div>
  </div>
}
@if (!deletionSuccessful) {
  @if (hasCancelableMembership) {
    <div class="message">
      <h1>Close Account</h1>
      <img src="/assets/privacy/attention.svg">
      <h2>Looks like you still have an active TYT membership</h2>
      <p>You will need to cancel your TYT membership before you can close your
        account and delete your data. In some cases you may have
        to wait some time after cancelling before you can delete your data.
        If you want to delete your account without waiting, please contact TYT Support
        by emailing support&#64;tytnetwork.com.
      </p>
      <button mat-raised-button color="primary" (click)="goBack()">Go Back</button>
    </div>
  }
  @if (!hasCancelableMembership) {
    <h1>
      <img src="/assets/privacy/attention.svg"> Delete Account
    </h1>
    <button mat-raised-button color="primary" (click)="goBack()">Go Back</button>
    @if (!showPasswordConfirmation) {
      <div class="notice">
        This action will result in the automatic and permanent deletion of your TYT account &amp; associated user
        data.
        If you do <strong>not</strong> wish to delete your account and data with TYT, but have
        questions, please visit <a href="https://help.tyt.com">TYT Help</a> instead.
      </div>
      Please review the following before continuing:
      <div class="legal">
        <ul class="points">
          <li>
            <strong>Important:</strong> If you currently have TYT membership purchased via the the App Store
            or Google Play your renewal payments may not automatically stop as a result
            of this action. Visit your Subscriptions page in the App Store or Play Store to
            ensure that your membership renewal payments are cancelled.
          </li>
          <li>
            <strong>Important:</strong> If you purchased TYT membership via YouTube, your renewal payments will not be
            automatically
            cancelled as a result of this action. If you wish to cancel on YouTube, visit your
            Memberships page on YouTube.
          </li>
          <li>Your account and all associated personal information will be deleted immediately</li>
          <li>
            This includes, but is not limited to:
            <ul>
              <li>Your name, avatar, profile information, and any other personally identifiable data</li>
              <li>Your email address and records of all previous email addresses which were associated
                with the account along with any information we maintain about you for email
              marketing purposes</li>
              <li>Watch history on TYT.com and our mobile apps</li>
              <li>Stored credit card information (if any)</li>
              <li>Your content customization settings (which shows/hosts you followed, etc)</li>
              <li>The comments you posted on TYT.com</li>
              <li>Messages included with membership gifts you've purchased</li>
              <li>Feedback you've given us about your membership experience</li>
            </ul>
          </li>
          <li>You will stop receiving email from TYT to the email address associated with the account</li>
          <li>Gifts purchased for others that have not yet been redeemed will still be redeemable up to
            one year from purchase date, but note that recipients of any unredeemed sponsorships you have purchased
          will not be able to send you a thank you note</li>
        </ul>
      </div>
      <div class="confirm-checkbox">
        <mat-checkbox name="confirm" [(ngModel)]="confirmEnabled">
          I understand this is permanent and cannot be undone.
        </mat-checkbox>
      </div>
    }
    @if (showPasswordConfirmation && !showSpinner) {
      <img src="/assets/privacy/attention.svg">
      <div class="password-label">Please enter your password to confirm that it's you</div>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Password</mat-label>
        <input matInput type="password" autocomplete="current-password"
          id="password" name="password" [(ngModel)]="password" />
        </mat-form-field>
        @if (errorMsg) {
          <div class="alert alert-danger">{{errorMsg}}</div>
        }
      }
      @if (showSpinner) {
        <app-spinner></app-spinner>
      }
      <div class="confirm-button" [class.enabled]="confirmEnabled">
        <button mat-raised-button [disabled]="!confirmEnabled" (click)="submit()">
          Delete my account and personal information
        </button>
      </div>
    }
  }
</div>